import {useContext,useRef,useState} from "react";
import {LiftCrmClientContext} from "./LiftCrmClientActions";

export default function LiftCancellationAction({sale,onDone}) {
  const context=useContext(LiftCrmClientContext);
  const [open,setOpen]=useState(false),[reason,setReason]=useState(""),[replacementId,setReplacementId]=useState("");
  const [busy,setBusy]=useState(false),[error,setError]=useState("");
  const intent=useRef(null);
  const record=sale?.record || sale || {};
  const id=sale?.liftPedidoId || record.liftPedidoId;
  const sid=sale?.storeId || record.storeId;
  const role=context?.authenticatedUser?.role;
  if(!id || !["manager","admin","superadmin"].includes(role) || sale?.crossStore) return null;
  const submit=async()=>{
    if(busy)return;
    if(!reason.trim()){setError("Informe o motivo.");return;}
    if(!window.confirm(`Confirmar ${replacementId ? "substituição" : "cancelamento"} do pedido #${id}? O registro será preservado.`))return;
    setBusy(true);setError("");
    try{
      intent.current ||= `cancel_${window.crypto?.randomUUID?.() || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`;
      const r=await fetch(`/api/lift/sales/${sid}/${id}/cancel`,{method:"POST",credentials:"same-origin",
        headers:{"Content-Type":"application/json"},body:JSON.stringify({reason,replacementId:replacementId||null,intentId:intent.current})});
      const j=await r.json();
      if(!r.ok||!j.ok)throw Error(j.error||"Cancelamento não confirmado.");
      context?.onOriginLinked?.(j.sale);
      if(j.replacement)context?.onOriginLinked?.(j.replacement);
      setOpen(false);onDone?.();
    }catch(e){setError(e.message);}finally{setBusy(false);}
  };
  return <div style={{marginTop:16,borderTop:"1px solid #ddd",paddingTop:12}}>
    <button onClick={()=>setOpen(v=>!v)} disabled={busy}>Venda cancelada / substituída</button>
    {open&&<div style={{display:"grid",gap:8,marginTop:10}}>
      <label>Motivo<textarea value={reason} maxLength={1000} onChange={e=>{setReason(e.target.value);intent.current=null;}} disabled={busy}/></label>
      <label>Pedido novo, se foi refeita<input value={replacementId} inputMode="numeric" onChange={e=>{setReplacementId(e.target.value.replace(/\D/g,""));intent.current=null;}} disabled={busy}/></label>
      <small>Somente da mesma loja. O novo pedido herda o vínculo e a origem, sem alterar o vendedor financeiro.</small>
      {error&&<div role="alert">{error}</div>}
      <button disabled={busy} onClick={submit}>{busy?"Salvando…":"Confirmar"}</button>
    </div>}
  </div>;
}
